import { PortisAdapter } from '@shapeshiftoss/hdwallet-portis'
import { PortisIcon } from 'components/Icons/PortisIcon'

export const PortisConfig = {
  adapter: PortisAdapter,
  icon: PortisIcon,
  name: 'Portis',
}
